import ApolloClient from "apollo-boost"
import { getCookie } from "../lib/api"

export const client = new ApolloClient({
  headers: { "X-CSRFToken": getCookie("csrftoken") },
})
